import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { CreateInvitationConfigArgs } from "./createInvitationConfig"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { WelcomeInvitationConfig } from "@/models/welcomeInvitationConfig"

export interface UpdateInvitationConfigArgs extends CreateInvitationConfigArgs { }

export interface IUpdateInvitationConfigArgsParams {
  eventAlbumId?: number
}

export async function updateInvitationConfig(invitationConfig: UpdateInvitationConfigArgs, eventVaultId: number, albumId?: number) {
  if (!eventVaultId) {
    throw new Error("Missing `eventVaultId` when attempting to update invitation config. Please ensure `eventVaultId` is provided.")
  }

  const options: AxiosRequestConfig = {}
  const params: IUpdateInvitationConfigArgsParams = {
    eventAlbumId: albumId,
  }

  if (params.eventAlbumId) {
    options.params = params
  }

  const response = await v1.patch(`/events/${eventVaultId}/invitation`, invitationConfig, options)

  return WelcomeInvitationConfig.fromResponse(response.data.data)
}

export const UPDATE_INVITATION_CONFIG = "updateInvitationConfig"

export function useUpdateInvitationConfig(eventVaultId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: [UPDATE_INVITATION_CONFIG, eventVaultId, albumId],
    mutationFn: (invitationConfig: UpdateInvitationConfigArgs) => updateInvitationConfig(invitationConfig, toValue(eventVaultId)!, toValue(albumId)),
  })
}
